import { render, staticRenderFns } from "./export-talk-category.vue?vue&type=template&id=0f9b4a1d&scoped=true&"
import script from "./export-talk-category.vue?vue&type=script&lang=js&"
export * from "./export-talk-category.vue?vue&type=script&lang=js&"
import style0 from "./export-talk-category.vue?vue&type=style&index=0&id=0f9b4a1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9b4a1d",
  null
  
)

export default component.exports